// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"d1264cc3","306":"aace1e5c","496":"de09568e","893":"62fbc092"}[chunkId] + ".chunk.js";
};